module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("8")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Das Kind")]), _vm._v(", dem ein\nfürstlich Kleid"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nman anzog, und das Juwelen um seinen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nNacken trägt, verliert alle Freude an seinem"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nSpiel, behindert vom Kleid bei jedem Schritt.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Aus Furcht, es könnte zerreißen, vom"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nStaube befleckt sein, hält es sich fern von"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nder Welt und fürchtet beinah sich zu regen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Mutter, es ist kein Gewinn im Zwang"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndeines Putzes, wenn er uns ausschließt"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nvom heilsamen Staube der Erde, wenn"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ner des Rechts uns beraubt, hinzuzutreten"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nzum großen Markt des gemeinen menschlichen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nLebens. "), _c('a', {
    attrs: {
      "id": "page11",
      "title": "wedi/cal"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5729104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0009.vue
// module id = 81
// module chunks = 0